import { lazy as lazyLoad } from 'react';

import { route } from './constants';

import type { RouteDefinition } from '../../route';

const lazy = {
    DashboardPage: lazyLoad(async () => {
        const { DashboardPage } = await import('./Dashboard');

        return { default: DashboardPage };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'navigation.dashboard',
        page: lazy.DashboardPage,
        path: route.patterns.dashboard,
    },
];
